<template>
  <div :style="mainStyle" class="app-wrapper">
    <div v-if="isLoading" class="loading-screen">
      <div class="loading-bar">
        <div class="loading-bar__progress"></div>
      </div>
      <p class="loading-text">Loading menu…</p>
    </div>
    <div v-else-if="loadingError" class="loading-error">
      <p>We’re having trouble loading the menu. Please refresh the page.</p>
    </div>
    <div v-else>
      <vue-headful
        :title="data.title"
        :head="{
          'link[rel=icon]': {href: data.favicon_uri}
      }"
      />
      <app-header v-bind:data="data"></app-header>
      <div>
        <section class="page-info set-bg" v-bind:style="{ backgroundImage: `url('${data.bg_img_url + '?v='+data.last_updated}')`}"></section>
      </div>
      <router-view v-if="data" v-bind:data="data" v-bind:siteData="data"/>
      <app-footer v-bind:data="data"></app-footer>
    </div>
  </div>
</template>

<script>
const url = process.env.ROOT_API

import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import axios from 'axios'
import moment from 'moment'
import { itemsStorage } from './main.js'

export default {
  components: {
    'app-header': Header,
    'app-footer': Footer,
  },
  data () {
    return {
      data: null,
      lastUpdate: '',
      mainStyle: "--main: #666666; --main-hover: #555555",
      isLoading: true,
      loadingError: false
    }
  },
  mounted() {
    if (localStorage.last_update) {
      this.lastUpdate = localStorage.last_update
    }
    itemsStorage.$on('updateItem', (i) => {
      this.lastUpdate = localStorage.last_update
    });

    this.clearStorage()
  },
  created: function() {
    const params = {};
    if (['development', 'staging'].includes(process.env.NODE_ENV)) {
      params.hash = localStorage.getItem('dev_site_hash')
    }
    axios.get(url, {params})
      .then(response => {
        this.data = response.data.data;
        localStorage.stripe_key = this.data.stripe_pub_key;
        this.mainStyle = "--main: "+response.data.data.colors.primary+"; --main-hover: "+response.data.data.colors.primary_darker;
        this.isLoading = false;
        this.loadingError = false;

        // Install GTM if gtm_code is present
        if (this.data.gtm_code) {
          this.installGTM(this.data.gtm_code);
        }
      })
      .catch(err => {
        console.error("Error fetching data:", err);
        this.isLoading = false;
        this.loadingError = true;
      });

    this.clearStorage();
  },
  methods: {
    clearStorage: function() {
      const dateFormat = "YYYY-MM-DD HH:mm:ss";
      const now = moment();
      const lastUpdate = moment(this.lastUpdate, dateFormat);
      const duration = moment.duration(now.diff(lastUpdate));

      if(localStorage.last_update === '' || duration.asHours() > 3){
        localStorage.items = [];
        localStorage.calc = [];
        localStorage.total_items = 0;
        localStorage.total_amount = 0;
        localStorage.last_update = moment()
      }
    },
    installGTM(gtmCode) {
      if (!gtmCode) return;

      const script = document.createElement("script");
      script.innerHTML = `
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${gtmCode}');
        `;
      document.head.appendChild(script);

      const noscript = document.createElement("noscript");
      noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmCode}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
      document.body.appendChild(noscript);
    }
  }
}
</script>

<style scoped>
.app-wrapper {
  min-height: 100vh;
}

.loading-screen,
.loading-error {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  text-align: center;
}

.loading-bar {
  width: 200px;
  height: 6px;
  background-color: rgba(0, 0, 0, 0.08);
  border-radius: 999px;
  overflow: hidden;
}

.loading-bar__progress {
  width: 40%;
  height: 100%;
  background-color: var(--main, #666666);
  border-radius: 999px;
  animation: loading-progress 1.4s ease-in-out infinite;
}

.loading-text {
  margin-top: 18px;
  font-size: 1rem;
  color: #4a4a4a;
}

.loading-error p {
  max-width: 320px;
  color: #4a4a4a;
}

@keyframes loading-progress {
  0% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(100%);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue